import { PropertyTypeUseCase } from "./PropertyTypeUseCase";

export default class DefaultPropertyTypeUseCase implements PropertyTypeUseCase {
    getPropertyType = (propertyTypeDescription: string | undefined, propertySubTypeDescription: string | undefined): string | undefined => {
        return propertyTypeDescription
    }

    getPropertySubType = (propertyTypeDescription: string | undefined, propertySubTypeDescription: string | undefined): string | undefined => {
        return propertySubTypeDescription
    }
}